import { FieldValidator } from './field-validator'

export class PasswordTextFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        const invalidPasswordMessage = 'Password does not meet requirements. Minimum length is 12 characters.'
        return new Promise((resolve, reject) => {
            if (!this.isValidPassword(text)) {
                reject(invalidPasswordMessage)
            } else {
                resolve('')
            }
        })
    }

    public isValidPassword(text: string): boolean {
        return (
            this.isNotUndefined(text) &&
            this.isAtLeast12Characters(text) &&
            this.containsAnUppercase(text) &&
            this.containsALowercase(text) &&
            this.containsADigit(text) &&
            this.containsASpecialCharacter(text)
        )
    }

    private isNotUndefined(text: string): boolean {
        return text !== undefined
    }

    private isAtLeast12Characters(text: string): boolean {
        return text.length >= 12
    }

    private containsAnUppercase(text: string): boolean {
        return /[A-Z]/.test(text)
    }

    private containsALowercase(text: string): boolean {
        return /[a-z]/.test(text)
    }

    private containsADigit(text: string): boolean {
        return /\d/.test(text)
    }

    private containsASpecialCharacter(text: string): boolean {
        return /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(text)
    }
}
